import { createFileRoute } from "@tanstack/react-router"
import { SettingsShell } from "@/components/settings-shell"

const CANDIDATE_SETTINGS_NAV = [
  { to: "/candidate/settings/profile", label: "Profile" },
  { to: "/candidate/settings/support", label: "Support" },
] as const

export const Route = createFileRoute("/candidate/settings")({
  component: CandidateSettingsLayout,
})

function CandidateSettingsLayout() {
  return <SettingsShell items={[...CANDIDATE_SETTINGS_NAV]} />
}
